import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IUserStrings extends LocalizedStringsMethods {
    lsUsersTxt: string;
    lsManageUsersTxt: string;
    lsInActiveUsrsTxt: string;
    lsActiveUsrsTxt: string;
    lsAllUsrsTxt: string;
    lsCSVTxt: string;
    lsNoFilterTxt: string;
    lsClearFiltersTxt: string;
    lsUsrNameTxt: string;
    lsFNameTxt: string;
    lsLNameTxt: string;
    lsEmailTxt: string;
    lsRoleTxt: string;
    lsHomeTxt: string;
    lsOrgTxt: string;
    lsAddUsrTxt: string;
    lsUploadUsrTxt: string;
    lsDwnldTxt: string;
    lsExportUsrTxt: string;
    lsDownloadProfileTxt: string;
    lsTestFilterHdrTxt: string;
    lsOkTxt: string;
    lsExportUsrSuccessTxt: string;
    lsPrintTxt: string;
    lsUsrListFilter: string;
    lsFilterTxt: string;
    lsUsrAddSuccessTxt: string;
    lsUsrUpdateSuccessTxt: string;
    lsPassResetSuccessTxt: string;
    lsPassResetFailTxt: string;
    lsActivateTxt: string;
    lsDeActivateTxt: string;
    lsTotalUsrsTxt: string;
    lsConfirmPassResetHdrTxt: string;
    lsConfirmPassResetTxt: string;
    lsActionTxt: string;
    lsEditTxt: string;
    lsResetTxt: string;
    lsCanResetTxt: string;
    lsYesTxt: string;
    lsUsrSuccessMsgTxt: string;
    lsDeactivatedTxt: string;
    lsActivatedTxt: string;
    lsViewStatus: string;
    lsViewed: string;
    lsNotViewed: string;
    lsTotalSharees: string;
    lsView: string;
    lsActiveTxt: string;
    lsNoTxt: string;
}

let strings: IUserStrings;
export default strings = new LocalizedStrings({
    en: {     
        lsUsersTxt: 'Users',
        lsManageUsersTxt: 'Manage Users',
        lsInActiveUsrsTxt: 'Inactive Users',
        lsActiveUsrsTxt: 'Active Users',
        lsAllUsrsTxt: 'All Users',
        lsCSVTxt: 'CSV',
        lsNoFilterTxt: 'No filters applied',
        lsClearFiltersTxt: 'Clear Filters',
        lsUsrNameTxt: 'Username',
        lsFNameTxt: 'First Name',
        lsLNameTxt: 'Last Name',
        lsEmailTxt: 'Email',
        lsRoleTxt: 'Role',
        lsHomeTxt: 'Home',
        lsOrgTxt: 'Organization',
        lsOrgsTxt: 'Organization(s)',
        lsAddUsrTxt: 'Add User',
        lsUploadUsrTxt: 'Upload New Users',
        lsDwnldTxt: 'Download',
        lsExportUsrTxt: 'Export User List',
        lsDownloadProfileTxt: 'Download Profile List',
        lsTestFilterHdrTxt: 'Profile List Filter',
        lsOkTxt: 'Ok',  
        lsExportUsrSuccessTxt: 'Users exported successfully without tests!',           
        lsPrintTxt: 'Print',
        lsUsrListFilter: 'User List Filter',
        lsFilterTxt: 'Filter',
        lsUsrAddSuccessTxt: 'User added successfully!',
        lsUsrUpdateSuccessTxt: 'User updated successfully!',
        lsPassResetSuccessTxt: 'Password reset successfully!',
        lsPassResetFailTxt: 'Password could not be reset. Please try again!',
        lsActivateTxt: 'Activate',
        lsDeActivateTxt: 'Deactivate',
        lsTotalUsrsTxt: 'Total {0} Users',
        lsConfirmPassResetHdrTxt: 'Confirm password reset',        
        lsConfirmPassResetTxt: 'Are you sure you want to reset the password for',
        lsActionTxt: 'Action',
        lsEditTxt: 'Edit',
        lsResetTxt: 'Reset',
        lsCanResetTxt: 'User password can be reset',
        lsYesTxt: 'Yes',
        lsNoTxt: 'No',
        lsUsrSuccessMsgTxt: 'User {0} successfully!',
        lsDeactivatedTxt: 'deactivated',
        lsActivatedTxt: 'activated',
        lsViewStatus: 'View status',
        lsViewed: 'Viewed',
        lsNotViewed: 'Not Viewed',
        lsTotalSharees: 'Total Sharees',
        lsView: 'View',
        lsActiveTxt: 'Active'
    },
    es: {
        lsUsersTxt: 'Usuarios',
        lsManageUsersTxt: 'Administrar usuarios',
        lsInActiveUsrsTxt: 'Usuarios inactivos',
        lsActiveUsrsTxt: 'Usuarios activos',
        lsAllUsrsTxt: 'Todos los usuarios',
        lsCSVTxt: 'CSV',
        lsNoFilterTxt: 'No se aplicaron filtros',
        lsClearFiltersTxt: 'Borrar filtros',
        lsUsrNameTxt: 'Nombre de usuario',
        lsFNameTxt: 'Nombre de pila',
        lsLNameTxt: 'Apellido',
        lsEmailTxt: 'Email',
        lsRoleTxt: 'Papel',
        lsHomeTxt: 'Casa',
        lsOrgTxt: 'Organización',
        lsOrgsTxt: 'Organización (es)',
        lsAddUsrTxt: 'Agregar usuario',
        lsUploadUsrTxt: 'Subir nuevos usuarios',
        lsDwnldTxt: 'Descargar',
        lsExportUsrTxt: 'Exportar lista de usuarios',
        lsDownloadProfileTxt: 'Descargar la lista de perfiles',
        lsTestFilterHdrTxt: 'Profile List Filter',
        lsOkTxt: 'De acuerdo',  
        lsExportUsrSuccessTxt: 'Usuarios exportados exitosamente sin pruebas!',           
        lsPrintTxt: 'Impresión',
        lsUsrListFilter: 'Filtro de lista de usuarios',
        lsFilterTxt: 'Filtrar',
        lsUsrAddSuccessTxt: 'Usuario agregado con éxito!',
        lsUsrUpdateSuccessTxt: 'Usuario actualizado con éxito!',
        lsPassResetSuccessTxt: 'Restablecimiento de contraseña con éxito!',
        lsPassResetFailTxt: 'La contraseña no se pudo restablecer. Inténtalo de nuevo!',
        lsActivateTxt: 'Activar',
        lsDeActivateTxt: 'Desactivar',
        lsTotalUsrsTxt: 'Total de {0} usuarios',
        lsConfirmPassResetHdrTxt: 'Confirmar restablecimiento de contraseña',        
        lsConfirmPassResetTxt: '¿Seguro que quieres restablecer la contraseña para',
        lsActionTxt: 'Acción',
        lsEditTxt: 'Editar',
        lsResetTxt: 'Reiniciar',
        lsCanResetTxt: 'La contraseña del usuario se puede restablecer',
        lsYesTxt: 'Sí',
        lsNoTxt: 'No',
        lsUsrSuccessMsgTxt: 'User {0} successfully!',
        lsDeactivatedTxt: 'deactivated',
        lsActivatedTxt: 'activated',
        lsViewStatus: 'View status',
        lsViewed: 'Viewed',
        lsNotViewed: 'Not Viewed',
        lsTotalSharees: 'Total Sharees',
        lsView: 'View',
        lsActiveTxt: 'Active'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/user/string.user.tsx